import { useId } from 'react'
import { useSection } from '../../cms/cms-context'
import { useGsapReveal } from '../../hooks/useGsapReveal'
import ClientReachMap from './ClientReachMap'

export default function ClientReach() {
  const cms = useSection()
  const id = useId()
  const ref = useGsapReveal<HTMLElement>({ y: 24 })

  return (
    <section ref={ref} id="client-reach" aria-labelledby={`${id}-title`} className="relative overflow-hidden border-y border-line-soft bg-surface py-20 sm:py-28">
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8">
        <div className="mb-10 flex flex-col justify-between gap-6 lg:mb-12 lg:flex-row lg:items-end lg:gap-12">
          <div className="max-w-2xl">
            <p {...cms.field('eyebrow')} className="flex items-center gap-3 label text-lime">
              <span aria-hidden="true" className="h-px w-9 coachline" />
              {cms.text('eyebrow', 'Across Pakistan')}
            </p>
            <h2 id={`${id}-title`} {...cms.field('title')} className="mt-5 font-display text-display-2 text-platinum">
              {cms.text('title', 'Different cities. The same trust.')}
            </h2>
          </div>
          <p {...cms.field('lede')} className="max-w-[390px] text-sm leading-relaxed text-steel">
            {cms.text('lede', 'From our showroom in Islamabad to roads across Pakistan, our clients are part of the Sultan Motors family.')}
          </p>
        </div>

        <ClientReachMap />
      </div>
    </section>
  )
}
